import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { engagementModels } from '../data/profile';
import { Reveal } from './Reveal';
import { SectionLabel } from './SectionLabel';
export function EngagementModels() {
  return <section aria-label="Ways to work together" className="w-full bg-canvas py-20 lg:py-28" data-id="element-251" data-mp="u521ezu6iu10">
      <div className="mx-auto max-w-shell px-6 sm:px-8" data-id="element-252" data-mp="y6na08zokm5e">
        <Reveal data-id="element-253" data-mp="y642znbkji65">
          <SectionLabel data-id="element-254" data-mp="y4kljte6f12s">Ways To Engage</SectionLabel>
          <h2 className="mt-6 max-w-2xl font-serif text-[32px] font-semibold leading-[1.12] tracking-[-0.015em] text-navy sm:text-4xl lg:text-[44px]" data-id="element-255" data-mp="134yhid2i6kkg">
            Three ways boards and leadership teams bring Kevin in
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-8 lg:grid-cols-3" data-id="element-256" data-mp="1cxmd54hqyihl">
          {engagementModels.map((model, index) => <Reveal key={model.title} delay={index * 0.07} data-id="element-257" data-mp="1lvyea0g8oyoa" data-mpi={index}>
              <article className="flex h-full flex-col border border-line bg-white p-8 transition-[border-color,box-shadow] duration-200 ease-premium hover:border-navy/30 hover:shadow-[0_10px_40px_rgba(15,23,42,0.07)]" data-id="element-258" data-mp="1lwhlon89k4o2">
                <h3 className="font-serif text-[24px] font-semibold leading-tight tracking-[-0.01em] text-navy" data-id="element-259" data-mp="1y67gjaq6hjzf">
                  {model.title}
                </h3>
                <p className="mt-4 text-[15px] leading-[1.7] text-charcoal-light" data-id="element-260" data-mp="1o7873pxl9kbd">
                  {model.description}
                </p>
                <ul className="mt-7 space-y-2.5 border-t border-line pt-6" data-id="element-261" data-mp="2gucg05zsyisf">
                  {model.points.map(point => <li key={point} className="flex items-start gap-2.5 text-[14px] text-charcoal" data-id="element-262" data-mp="2c2uftk5lsm8i">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-metal" aria-hidden="true" data-id="element-263" data-mp="275b0egx663ez" />
                      {point}
                    </li>)}
                </ul>
                <Link to="/contact" className="group mt-auto inline-flex items-center gap-2 pt-8 text-[13px] font-semibold uppercase tracking-label text-navy transition-colors duration-150 ease-premium hover:text-metal focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy focus-visible:ring-offset-2" data-id="element-264" data-mp="2zsyi9o722fxx">
                  Discuss this
                  <ArrowRightIcon className="h-3.5 w-3.5 transition-transform duration-200 ease-premium group-hover:translate-x-1" aria-hidden="true" data-id="element-265" data-mp="t4692m0z7tnt" />
                </Link>
              </article>
            </Reveal>)}
        </div>
      </div>
    </section>;
}